/**
 * SHA-256 (hex) of the normalized e-mail — the value Seznam expects as "eid".
 *
 * Normalization is trim + lowercase, so the plaintext address never leaves the page.
 * Returns null when there is nothing to hash or no WebCrypto is available.
 */
export async function hashEmailSha256(email, cryptoImpl = globalThis.crypto) {
    const normalized = email?.trim().toLowerCase();
    if (!normalized || !cryptoImpl?.subtle) {
        return null;
    }
    const digest = await cryptoImpl.subtle.digest("SHA-256", new TextEncoder().encode(normalized));
    return Array.from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
}
